import { Link } from 'react-router-dom';
import { HOME_PAGE_IMAGES_PUBLIC_PATH } from '../assets/home_page_assets';

const floorPlanToolsImageSrc = `${HOME_PAGE_IMAGES_PUBLIC_PATH}/2d-floorplan-tools.webp`;

function FloorPlanToolsHighlightSection() {
  return (
    <section
      id="floor-plan-tools"
      className="why-choose-section container section"
      aria-label="Floor plan design tools"
    >
      <div className="section-heading">
        <h2>
          <span className="shop-furniture-showcase__title-accent shop-furniture-showcase__title-accent--gradient">
            DIY
          </span>
          : From a Sketch or Floor Plan to{' '}
          <span className="shop-furniture-showcase__title-accent shop-furniture-showcase__title-accent--gradient">
            Realistic Visuals
          </span>
        </h2>
      </div>

      <div className="why-choose-feature-list">
        <article className="why-choose-feature-card">
          <div className="why-choose-feature-card__visual" aria-hidden="false">
            <img
              src={floorPlanToolsImageSrc}
              alt="MyRoomsAI 2D floor plan design and visualization tools"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="why-choose-feature-card__content">
            <h3 className="why-choose-feature-card__title">Everything for Home Design in One Place</h3>
            <p className="why-choose-feature-card__text">
              An all-in-one tool made for designers, real estate professionals, and homeowners who
              want to turn floor plans into clear visual design results. Upload an existing 2D floor
              plan, draw your own layout, or create a new concept with AI, then transform it into an
              open-top 3D view or a realistic room image.
            </p>
            <Link
              to="/ai-tools/ai-2d-floorplan-to-3d"
              className="btn btn-primary why-choose-feature-card__cta"
            >
              Explore Floor Plan Tools
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}

export default FloorPlanToolsHighlightSection;
